export default (array) => {
    var treeData = [];
    var treeMaps = {};
    var treeSize = array.length;

    for (let i = 0; i < treeSize; i++) {
        treeMaps[array[i]["id"]] = array[i];
    }

    for (let i = 0; i < treeSize; i++) {
        var node = treeMaps[array[i]["pid"]];
        if (node) {
            if(node.hasOwnProperty('children') === false) {
                node["children"] = [];
            }
            node["children"].push(array[i]);
        } else {
            
            if(array[i].pid === 0) {
                treeData.push(array[i]);
            }
        }
    }

    sortTree(treeData);

    return treeData;
};

function sortTree(tree) {
    // tree.sort(function(a ,b) {
    //     if(a.sort > b.sort) {
    //         return 1;
    //     } else if(a.sort < b.sort) {
    //         return -1;
    //     }
    //     return 0;
    // });

    // tree.forEach(d => {
    //     if(d.children) {
    //         sortTree(d.children);
    //     }
    // });

    tree.sort(function(a ,b) {
        if(a.orderNum > b.orderNum) {
            return 1;
        } else if(a.orderNum < b.orderNum) {
            return -1;
        }
        return 0;
    });

    tree.forEach(d => {
        if(d.children) {
            sortTree(d.children);
        }
    });
}